import { useCallback, useLayoutEffect, useRef } from 'react';

export function useDocumentTitle(initialTitle?: string) {
  const defaultTitle = useRef(document.title);

  const setTitle = useCallback((title: string) => {
    document.title = title;
  }, []);

  useLayoutEffect(() => {
    if (initialTitle) {
      setTitle(initialTitle);
    }
    return () => {
      document.title = defaultTitle.current;
    };
  }, [initialTitle, setTitle]);

  return setTitle;
}
